import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Spinner from 'react-bootstrap/Spinner'

import { claimWaitlist, getWaitlistClaim } from '../../utilities/api'
import { storeCartSession } from '../../utilities/cartSessionTracking'

import './waitlistClaimPage.scss'

function rememberClaimedCart(payload) {
  const cartId = payload?.cartId
  if (!cartId) return false
  storeCartSession({
    cartId,
    sessionId: payload.sessionId,
  })
  sessionStorage.setItem('cart', JSON.stringify({ cartId }))
  return true
}

export default function WaitlistClaimPage() {
  const { token } = useParams()
  const navigate = useNavigate()
  const [state, setState] = useState('loading')
  const [message, setMessage] = useState('Holding your tickets…')

  useEffect(() => {
    let cancelled = false

    async function claimHold() {
      try {
        const preview = await getWaitlistClaim(token)
        if (cancelled) return
        const details = preview.data || {}
        if (rememberClaimedCart(details)) {
          navigate('/checkout')
          return
        }
        if (details.status !== 'offered' || details.expired) {
          setState('idle')
          setMessage(
            details.expired || details.status === 'expired'
              ? 'This hold has expired. If tickets are still available, join the waitlist again.'
              : details.status === 'claimed'
                ? 'These tickets were already claimed.'
                : 'This waitlist hold is no longer active.'
          )
          return
        }

        const claimed = await claimWaitlist(token)
        const saved = rememberClaimedCart(claimed.data)
        if (cancelled) return
        if (!saved) {
          setState('idle')
          setMessage('We could not put these tickets in your cart.')
          return
        }
        navigate('/checkout')
      } catch (error) {
        if (!cancelled) {
          try {
            const again = await getWaitlistClaim(token)
            if (rememberClaimedCart(again?.data)) {
              if (!cancelled) navigate('/checkout')
              return
            }
          } catch {
            // Show the claim error when the hold still cannot be resumed.
          }
        }
        if (cancelled) return
        setState('idle')
        setMessage(
          error?.response?.data?.error?.message ||
            'We could not put these tickets in your cart.'
        )
      }
    }

    claimHold()
    return () => {
      cancelled = true
    }
  }, [token, navigate])

  return (
    <main className="waitlist-claim">
      <Card body className="waitlist-claim__card">
        <h1>Your waitlist tickets</h1>
        <p>{message}</p>
        {state === 'loading' ? <Spinner animation="border" /> : null}
        {state === 'idle' ? (
          <Button variant="primary" onClick={() => navigate('/browse')}>
            Browse events
          </Button>
        ) : null}
      </Card>
    </main>
  )
}
